import {css} from '@emotion/css';
import React, {HTMLAttributes} from 'react';
import {Button} from './Button';
import {theme} from './Common';
import {Modal} from './Modal';
import {TextInput} from './TextInput';

export type CustomerPortalModalPaypalProps = {
  isOpen: boolean;
  setIsOpen: (value: boolean) => unknown;
  email: string;
  setEmail: (value: string) => unknown;
  nextClick: () => unknown;
};

export const CustomerPortalModalPaypal = ({
  isOpen,
  setIsOpen,
  email,
  setEmail,
  nextClick,
}: CustomerPortalModalPaypalProps) => (
  <Modal title='Paypal' isOpen={isOpen} setModal={setIsOpen}>
    <Content>
      <TextInput
        type='email'
        placeholder='Paypal E-mail Address'
        value={email}
        setValue={setEmail}
        containerClassName={css({width: '100%'})}
      />
      <Button buttonStyle='primary' onClick={nextClick} className={buttonAditionalStyle}>
        Next
      </Button>
    </Content>
  </Modal>
);
const Content = (args: HTMLAttributes<HTMLDivElement>) => (
  <div
    className={css({
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'center',
      justifyContent: 'center',
    })}
    {...args}
  />
);
const buttonAditionalStyle = css({marginTop: theme.spacings.medium});
